import * as React from 'react';
var ProgressBar = function ProgressBar(_ref) {
  var showingNow = _ref.showingNow,
    totalResult = _ref.totalResult;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("progress", {
    className: "progress-bar",
    value: showingNow,
    max: totalResult
  }));
};
export default ProgressBar;